import styled from 'styled-components';

import { ReactPortal } from '#/components/Portal';
import { MEDIA_QUERIES } from '#/hooks/useResponsiveValue';
import { remify } from '#/service/utils';
import { tb } from '#/store/translation/translation.store';

import { Step, StepIndicator } from './StepIndicator';

const StyledStepIndicator = styled(StepIndicator)`
  margin: initial;
  padding: 0;

  @media ${MEDIA_QUERIES.lg} {
    padding-right: ${remify(16)};
    right: 0;
  }
`;

export const SignupStepIndicator = ({
  currentStep,
}: {
  currentStep: number;
}) => (
  <ReactPortal>
    <StyledStepIndicator currentStep={currentStep}>
      <Step>{tb('registration.pageTitle')}</Step>
      <Step>{tb('iap.selectYourPlan')}</Step>
      <Step>{tb('iap.setUpYourPayment')}</Step>
    </StyledStepIndicator>
  </ReactPortal>
);
